<template>
  <div>
    <contnet/>
  </div>
</template>

<script>
import contnet from '@/components/contnet.vue'

export default {
  name: 'index',
  components: {
    contnet
  }
}
</script>
